import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../Tooltip/Tooltip';

const PlanSpeedIndecator = (props) => {
  const iconClass = props.disabled ? 'plan-icon-disabled' : '';
  const textClass = props.disabled ? 'plan-text-disabled' : '';
  const directionClass = props.speedData.direction === 'upload' ? 'plan-up' : 'plan-down';
  const directionIconClass = props.speedData.direction === 'upload' ?
    'fa-arrow-circle-o-up'
    : 'fa-arrow-circle-o-down';
  return (
    <div>
      <div
        className={`${directionClass} fa ${directionIconClass} font-large left ${iconClass}`}
      />
      <div className={`plan-speed-text ${textClass}`}>
        {props.speedData.caveat}&nbsp;
        <Tooltip
          title={` ${props.speedData.speed}Mbps`}
          modalHeading={'How fast is it?'}
        >
          <div>
            <p>Mbps = Megabits per second.</p>
            <p>
              Based on Spark National Peak Time Average Speeds (MBNZ March
              2025). (Skinny runs on Spark&#39;s awesome network). You may
              experience a higher or lower speed than this. Actual speeds will
              be affected by NZ and overseas networks, your modem and your
              personal devices, Wi-Fi capability, internal home wiring and other
              factors.
            </p>
          </div>
        </Tooltip>{' '}
        Avg {props.speedData.direction}*{props.children}
      </div>
    </div>
  );
};

PlanSpeedIndecator.propTypes = {
  speedData: PropTypes.shape(
    {
      caveat: PropTypes.string,
      speed: PropTypes.number,
      direction: PropTypes.oneOf(['upload', 'download'])
    }
  ).isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node
};

export default PlanSpeedIndecator;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/PlanSpeedIndecator/PlanSpeedIndecator.js
 **/